import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Steps } from "antd";

export class Stepper extends React.Component {
  static defaultProps = {
    current: 0,
    direction: "horizontal",
    progressDot: false,
    size: "default",
    status: "process",
  };

  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Index indicating which step is active */
    current: PropTypes.number,
    /** String indicating which direction the stepper is along */
    direction: PropTypes.oneOf(["horizontal", "vertical"]),
    /** Steps to be rendered */
    items: PropTypes.arrayOf(
      PropTypes.shape({
        /** Description of the step */
        description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        /** Icon of the step */
        icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        /** Status of the step */
        status: PropTypes.oneOf(["wait", "process", "finish", "error"]),
        /** Title of the step */
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      })
    ),
    /**  Can customize the progress dot by setting it to a function */
    progressDot: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    /** Size of the step bar */
    size: PropTypes.oneOf(["default", "small"]),
    /** Status of the current step */
    status: PropTypes.oneOf(["wait", "process", "finish", "error"]),
  };

  render() {
    const { className, current, direction, items, progressDot, size, status } =
      this.props;

    const stepperClassNames = classNames("Stepper", className);
    const stepperProps = {
      current,
      direction,
      items,
      progressDot,
      size,
      status,
    };

    return (
      <div className={stepperClassNames}>
        <Steps {...stepperProps} />
      </div>
    );
  }
}

export default Stepper;
